import React from 'react';
import { useCountdown } from '../contexts/CountdownContext';
export function StickyBar() {
  const {
    label
  } = useCountdown();
  return <div className="sticky top-0 z-50 flex h-11 items-center justify-center px-3 text-white sm:h-12" style={{
    background: 'linear-gradient(90deg, #c9a84c 0%, #1a4a2e 100%)'
  }} data-id="element-101" data-mp="12m0klnocqc58">
      <p className="flex items-center gap-2 truncate text-[12px] font-bold tracking-tight sm:text-[13px]" data-id="element-102" data-mp="sv5z4lixjgku">
        <span className="hidden sm:inline" data-id="element-103" data-mp="nxxg6ipyj8ij">
          🔥 OFERTA DE LANZAMIENTO — El Súper Bono de Numerología se incluye GRATIS — Expira en:
        </span>
        <span className="sm:hidden" data-id="element-104" data-mp="ev4nqc51gqr4">🔥</span>
        <span className="rounded bg-black/35 px-2 py-0.5 font-mono tabular-nums text-gold-light" data-id="element-105" data-mp="ew6b9g38r5pq">
          {label}
        </span>
        <span className="font-black" data-id="element-106" data-mp="299xlagphfrlp">— $9.99 USD</span>
      </p>
    </div>;
}